import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Ad from '../ad/ad';

function generateTagData(tags = []) {
  const data = {};

  tags.forEach(tag => {
    const { name } = tag;
    const slicedName = name.slice(0, 1);

    // there are cases of no star, hence this does not always work
    if (!data.advertiser && slicedName === '*') {
      data.advertiser = name
        .slice(1)
        .replace(/_/g, ' ')
        .replace(/\s?advertorial/g, '')
        .toUpperCase();
    } else if (!data.type && slicedName === '_') {
      data.type = name;
    }
  });

  return data;
}

export function getAdvertorialEyebrow(tags, tagData = false) {
  const data = tagData || generateTagData(tags);
  let copy = 'Created For and Commissioned By: ';

  if (!data.advertiser) {
    return 'Sponsored Content';
  }

  if (data.type === '_syndicated') {
    copy = 'Paid For And Posted By: ';
  }

  copy += data.advertiser;

  return copy;
}

export function isAdvertorial(tags = []) {
  return !!tags.filter(tag => tag.slug === 'advertorial').length;
}

export default class Advertorial extends Component {
  shouldComponentUpdate() {
    return false;
  }

  getBranding(slot) {
    let type;

    switch (slot) {
      case '_custom':
        type = ['fast-co-works'];
        break;
      case '_brandview':
        type = ['fast-co-works', 'inc-brand-view'];
        break;
      case '_syndicated':
        type = (
          <Ad
            {...this.props.adModel}
            noLazyLoad={true}
            slug="false"
            pos="atf"
            name="flexiblelogo"
          />
        );
        break;
      default:
        type = null;
        break;
    }

    if (Array.isArray(type)) {
      return (
        <ul className="advertorial__list">
          {type.map(item =>
            <li
              key={item}
              className={`advertorial__item advertorial__item--${item}`}
            />
          )}
        </ul>
      );
    }

    return type;
  }

  render() {
    const { modifier, tags, section } = this.props;
    const data = generateTagData(tags);
    const eyebrow = getAdvertorialEyebrow(tags, data);

    if (section) {
      return <h3 className="advertorial__module-deck">{eyebrow}</h3>;
    }

    return (
      <div
        className={`advertorial ${modifier ? `advertorial--${modifier}` : ''}`}
      >
        {data.type || data.advertiser
          ? <div
              className={`advertorial__container ${modifier
                ? `advertorial__container--${modifier}`
                : ''}`}
            >
              {data.type && this.getBranding(data.type)}
              {data.advertiser
                ? <span className="advertorial__copy">
                    {eyebrow}
                  </span>
                : ''}
            </div>
          : null}
      </div>
    );
  }
}

Advertorial.defaultProps = {
  modifier: '',
  section: '',
  adModel: {}
};

Advertorial.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  modifier: PropTypes.string,
  section: PropTypes.string,
  adModel: PropTypes.shape({})
};



// WEBPACK FOOTER //
// ./src/views/components/advertorial/advertorial.js